export default "__VITE_ASSET__0917ea37__"